// Mirrors backend/layers/shared/python/shared/validation.py AGE_GROUP_RANGES
const AGE_GROUP_RANGES = {
  infant: { weight_min: 2, weight_max: 20, height_min: 30, height_max: 90 },
  toddler: { weight_min: 5, weight_max: 30, height_min: 60, height_max: 130 },
  child: { weight_min: 10, weight_max: 80, height_min: 90, height_max: 170 },
  adolescent: { weight_min: 20, weight_max: 150, height_min: 120, height_max: 210 },
  adult: { weight_min: 20, weight_max: 300, height_min: 50, height_max: 250 },
};

function getAgeGroup(yearOfBirth) {
  const currentYear = new Date().getFullYear();
  const age = currentYear - yearOfBirth;

  if (age <= 1) return 'infant';
  if (age <= 5) return 'toddler';
  if (age <= 12) return 'child';
  if (age <= 19) return 'adolescent';
  return 'adult';
}

function getValidationRanges(yearOfBirth) {
  if (!yearOfBirth) return AGE_GROUP_RANGES.adult;
  const ageGroup = getAgeGroup(yearOfBirth);
  return AGE_GROUP_RANGES[ageGroup] || AGE_GROUP_RANGES.adult;
}

function validateWeight(weight, yearOfBirth) {
  if (!weight && weight !== 0) return null;
  const ranges = getValidationRanges(yearOfBirth);
  const ageGroup = yearOfBirth ? getAgeGroup(yearOfBirth) : 'adult';
  const w = parseFloat(weight);
  if (isNaN(w)) return null;
  if (w < ranges.weight_min || w > ranges.weight_max) {
    return `Weight must be between ${ranges.weight_min} and ${ranges.weight_max} kg for age group '${ageGroup}'`;
  }
  return null;
}

function validateHeight(height, yearOfBirth) {
  if (!height && height !== 0) return null;
  const ranges = getValidationRanges(yearOfBirth);
  const ageGroup = yearOfBirth ? getAgeGroup(yearOfBirth) : 'adult';
  const h = parseFloat(height);
  if (isNaN(h)) return null;
  if (h < ranges.height_min || h > ranges.height_max) {
    return `Height must be between ${ranges.height_min} and ${ranges.height_max} cm for age group '${ageGroup}'`;
  }
  return null;
}

export { AGE_GROUP_RANGES, getAgeGroup, getValidationRanges, validateWeight, validateHeight };
